import { useAIMode } from '@/contexts/AIModeContext';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { Zap, Brain, Mic, Wrench, ArrowRight, Lock } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const AI_FEATURES = [
  { icon: Brain, label: 'AI Evaluations', desc: 'Real-time signal detection & scoring' },
  { icon: Mic, label: 'Voice Transcription', desc: 'Live call transcription with Scribe' },
  { icon: Wrench, label: 'Field Repair', desc: 'AI-powered CRM data correction' },
];

export function UpgradePrompt() {
  const { showUpgrade, dismissUpgrade, blockedAction } = useAIMode();
  const navigate = useNavigate();

  return (
    <Dialog open={showUpgrade} onOpenChange={(open) => !open && dismissUpgrade()}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <div className="flex items-center gap-2 mb-1">
            <div className="h-8 w-8 rounded-lg bg-warning/10 flex items-center justify-center">
              <Lock className="h-4 w-4 text-warning" />
            </div>
            <Badge variant="outline" className="text-[10px] border-warning/30 text-warning">
              PRO FEATURE
            </Badge>
          </div>
          <DialogTitle className="text-lg">
            Upgrade to unlock AI-powered analysis
          </DialogTitle>
          <DialogDescription className="text-sm">
            {blockedAction ? (
              <><strong>{blockedAction}</strong> requires a Pro or Enterprise plan.</>
            ) : (
              <>AI features require a Pro or Enterprise plan.</>
            )}
          </DialogDescription>
        </DialogHeader>

        <div className="space-y-2 py-3">
          {AI_FEATURES.map(({ icon: Icon, label, desc }) => (
            <div key={label} className="flex items-center gap-3 p-2.5 rounded-lg bg-muted/50">
              <div className="h-8 w-8 rounded-md bg-primary/10 flex items-center justify-center shrink-0">
                <Icon className="h-4 w-4 text-primary" />
              </div>
              <div>
                <p className="text-sm font-medium text-foreground">{label}</p>
                <p className="text-[11px] text-muted-foreground">{desc}</p>
              </div>
            </div>
          ))}
        </div>

        <DialogFooter className="flex-col sm:flex-row gap-2">
          <Button variant="ghost" onClick={dismissUpgrade} className="text-[12px]">
            Maybe later
          </Button>
          <Button className="gap-1.5" onClick={() => { dismissUpgrade(); navigate('/usage'); }}>
              <Zap className="h-4 w-4" />
              View Plans
              <ArrowRight className="h-3 w-3" />
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
